module.exports = __webpack_public_path__ + "static/end_of_the_day-a177953f6ad6c320ebf35c2a762cf056.jpg";